import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ModalService } from "../../shared/services/modal.service";
import { AdminService } from "../../shared/services/admin.service";
import { ModalAdminCompanyComponent } from "./modal-admin-company/modal-admin-company.component";
import { ModalAdminCompanyRegisterComponent } from "./modal-admin-company-register/modal-admin-company-register.component";
import { Subject } from "rxjs";
import { empty } from "../../functions";
import { InterestService } from "../../shared/services/interest.service";
import { DomainService } from "../../shared/services/domain.service";
import { CompanyService } from "../../shared/services/company.service";
import { EducationService } from "../../shared/services/education.service";
import { catchError } from "rxjs/operators";
import { ModelCompanyprofile } from "../../model/model.companyprofile";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AdminCompanyElectionSignupModalComponent } from "./admin-company-election-signup-modal/admin-company-election-signup-modal.component";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { UserService } from "../../shared/services/user.service";
import { RoleTypes } from "../../guards/roletypes";

@Component({
  selector: "app-admin-companyprofiles",
  templateUrl: "./admin-companies.component.html",
  styleUrls: ["./admin-companies.component.scss"],
  standalone: false,
})
export class AdminCompaniesComponent implements OnInit, AfterViewInit {
  filterOpen = false;

  public view = {
    filters: {
      areaOfInterests: <string[]>[],
      educationareaOfInterests: [],
      lookingFor: "",
      sites: <any>[],
      queryParams: {
        SearchTerm: null,
        Location: null,
        AreaOfInterests: [],
        MaximumDistance: null,
        SortField: "createdOn",
        SortType: "Descending",
      },
    },
    filterOptions: {
      areaOfInterests: <any>[],
      sites: <any>[],
      status: <any>[],
      educationLevels: <any>[],
    },
  };

  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Profile image",
        name: "avatarUri",
        type: "image",
        class: "img-64",
      },
      {
        header_name: "Name",
        name: "name",
        type: "text",
      },
      {
        header_name: "Registration number",
        name: "registrationNumber",
        type: "text",
      },
      {
        header_name: "Street",
        name: "visitAddress",
        subName: "street",
        type: "text",
      },
      {
        header_name: "No.",
        name: "visitAddress",
        subName: "number",
        type: "text",
      },
      {
        header_name: "City",
        name: "visitAddress",
        subName: "city",
        type: "text",
      },
      {
        header_name: "Country",
        name: "visitAddress",
        subName: "country",
        type: "text",
      },
    ],
    // Endpoint is finalised in ngOnInit based on the current admin role.
    // Beheerder uses /company/all; ProfessionalAdmin and InternationalAdmin
    // use the regular /company GET endpoint (the only one they are allowed
    // to call). Default value here is overwritten before app-table loads.
    endpoint: "company",
    data: <any>[],
    buttons: [
      {
        class: "btn btn-info",
        event: "profile",
        text: "Profile",
      },
      {
        class: "btn btn-default",
        event: "election-signup",
        text: marker("Signup for election"),
      },
      {
        class: "btn btn-danger",
        event: "delete",
        text: "Delete",
      },

      {
        class: "btn btn-warning",
        event: "edit",
        text: "Edit",
      },
    ],
    class: "",
    reloadListener: new Subject(),
    queryParams: this.view.filters.queryParams,
  };

  constructor(
    public modal: ModalService,
    public companyService: CompanyService,
    public educationService: EducationService,
    public adminService: AdminService,
    public interest: InterestService,
    public domain: DomainService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {
    // Sub-admin roles (ProfessionalAdmin / InternationalAdmin) are not allowed
    // to call /company/all, but can call the regular /company endpoint. Pick
    // the endpoint that matches the current admin role.
    this.configTable.endpoint = this.userService.currentUserHasRole(
      RoleTypes.Beheerder
    )
      ? "company/all"
      : "company";

    this.view.filterOptions.educationLevels = [];
    // this.educationService.apiGetEducationLevels().pipe(catchError(this.adminService.handleError('apiGetEducationLevels', false))).subscribe((result: any) => {
    //   if (result) {
    //     result.data.map((educationLevel: any) => this.view.filterOptions.educationLevels.push({value: educationLevel.id, label: educationLevel.name}));
    //   }
    // });
    this.view.filterOptions.status = this.companyService.getCompanyStatuses();

    // Set area of interest filter options
    this.interest
      .apiGetAreaOfInterests()
      .pipe(
        catchError(
          this.adminService.handleError("apiGetAreaOfInterests", false)
        )
      )
      .subscribe((result: any) => {
        if (!empty(result)) {
          // Reassign a NEW array (not push): <app-filter-panel> reads options
          // via a signal input(), which only reacts to a new reference.
          this.view.filterOptions.areaOfInterests = result.data.map(
            (item: any) => ({ value: item.name, label: item.name })
          );
        }
      });

    // Set site filter options
    const sites = this.domain.getAllDomains();
    if (!empty(sites)) {
      sites.map((item: any) => {
        this.view.filterOptions.sites.push({
          value: item.id,
          label: item.url + " (" + item.code + ")",
        });
      });
    }
  }

  ngAfterViewInit() {
    this.route.params.subscribe((params: Params) => {
      if (params.id) {
        this.updateCompany(params);
      }
    });
  }

  /**
   * Add a new company
   */
  addCompany() {
    const modalOptions = { size: "xl", backdrop: "static" };

    const data = {
      entity: {} as ModelCompanyprofile,
    };

    this.modal
      .Modal(ModalAdminCompanyComponent, "Company", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.configTable.reloadListener.next(true);
        }
      })
      .catch((error) => {});
  }

  /**
   * Update a company
   *
   * @param $data
   */
  updateCompany($data: any) {
    const modalOptions = { size: "xl", backdrop: "static" };

    // Load full profile first
    if (!empty($data["id"])) {
      this.companyService
        .apiGetCompanyProfile($data["id"])
        .pipe(
          catchError(
            this.companyService.handleError("apiGetCompanyProfile", null)
          )
        )
        .subscribe((result) => {
          if (result) {
            const data = {
              entity: result,
            };

            this.modal
              .Modal(
                ModalAdminCompanyComponent,
                "Company",
                "",
                data,
                [],
                modalOptions
              )
              .then((result) => {
                if (result === true) {
                  this.configTable.reloadListener.next(true);
                }
              })
              .catch((error) => {});
          }
        });
    }
  }

  /**
   * Delete the opened company
   *
   * @param id
   */
  deleteCompany(id: string) {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.adminService.apiDeleteCompany(id).subscribe((result) => {
            // Reload data
            this.configTable.reloadListener.next(true);
          });
        }
      })
      .catch((error) => {});
  }

  /**
   * Open company profile (edit) page
   *
   * @param $id
   */
  openCompanyprofile($id: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(["/company/profile/" + $id])
    );
    window.open(url, "_blank");
  }

  signupElection($data: any) {
    const modalOptions = {
      size: "xl",
    };

    this.modal
      .Modal(
        AdminCompanyElectionSignupModalComponent,
        "",
        "",
        $data,
        [],
        modalOptions
      )
      .then(() => {})
      .catch(() => {});
  }

  /**
   * Register a company
   *
   * Shows modal with form
   */
  registerCompany() {
    const modalOptions = { size: "xl", backdrop: "static" };

    const data = {
      id: "",
      emailAddress: "",
      allowEmailNotifications: false,
      isSubscribedToNewsletter: false,
      companyName: "",
      phoneNumber: "",
      registrationNumber: "",
      visitAddress: {
        street: "",
        number: "",
        numberSuffix: "",
        postalCode: "",
        city: "",
        country: "",
      },
    };

    this.modal
      .Modal(
        ModalAdminCompanyRegisterComponent,
        "Company",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.configTable.reloadListener.next(true);
        }
      })
      .catch((error) => {});
  }

  /**
   * Handle button event of table
   *
   * @param $event
   */
  handleButtonEvent($event: any) {
    if (!empty($event["event"])) {
      switch ($event["event"]) {
        case "profile":
          this.openCompanyprofile($event["data"]["id"]);
          break;

        case "election-signup":
          this.signupElection($event["data"]);
          break;

        case "edit":
          this.updateCompany($event["data"]);
          break;

        case "delete":
          this.deleteCompany($event["data"]["id"]);
          break;
      }
    }
  }

  reloadData() {
    this.setQueryParams();

    this.configTable.reloadListener.next(true);
  }

  setQueryParams() {
    this.configTable.queryParams = this.view.filters.queryParams;
  }

  resetFilters() {
    this.view.filters = {
      areaOfInterests: <string[]>[],
      educationareaOfInterests: [],
      lookingFor: "",
      sites: <any>[],
      queryParams: {
        SearchTerm: null,
        Location: null,
        AreaOfInterests: [],
        MaximumDistance: null,
        SortField: "createdOn",
        SortType: "Descending",
      },
    };

    this.reloadData();
  }

  applyFilters() {
    this.reloadData();
  }
}
